import {AfterViewInit, Component, Input} from '@angular/core';
import {ModalConfig} from '../../../model/modal-config';
import {PageNames} from '../../../shared/page-names.enum';
import {Emitter} from '../../../shared/utils/emitter/emitter';
import {EmitterConstants} from '../../../shared/emitter-constants';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {OmapiIdConstants} from '../../../shared/omapi-id-constants';
import {ImageUtils} from '../../../shared/utils/image/image-utils';

@Component({
  selector: 'app-trial-success-modal',
  templateUrl: './trial-success-modal.component.html',
  styleUrls: ['./trial-success-modal.component.less']
})
export class TrialSuccessModalComponent implements AfterViewInit {

  @Input() omapiId: string;
  @Input() config: ModalConfig;
  @Input() trialOmapiId: string;

  componentName = PageNames.TRIAL_SUCCESS_MODAL;

  constructor(private navigationService: NavigationService) {
  }

  get logoUrl() {
    return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
  }

  public backPressed(): void {
    Emitter.of(EmitterConstants.BACK_PRESSED).emit({componentName: this.componentName, omapiId: this.trialOmapiId});
  }

  trialName(): string {
    return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.trialOmapiId);
  }


  ngAfterViewInit(): void {
    this.navigationService.resetNavigation();
  }

}
